import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderCargoOrderDriverSimulationResponseBodyModel {
  AB = "AB",
  ABA = "ABA",
  SABS = "SABS",
}

export type OrderCargoOrderDriverSimulationResponseBodySimulation = {
  contractRate: number;
  bonusRate: number | null;
  distance: number;
  totalCost: number;
};

export type OrderCargoOrderDriverSimulationResponseBodySimulations = {
  ab: OrderCargoOrderDriverSimulationResponseBodySimulation;
  aba: OrderCargoOrderDriverSimulationResponseBodySimulation;
  sabs: OrderCargoOrderDriverSimulationResponseBodySimulation;
};

export type OrderCargoOrderDriverSimulationResponseBody = {
  contractNotes: string | null;
  driverNotes: string | null;
  model: OrderCargoOrderDriverSimulationResponseBodyModel;
  simulations: OrderCargoOrderDriverSimulationResponseBodySimulations;
};

type OrderCargoOrderDriverSimulationResponse =
  HttpResponse<OrderCargoOrderDriverSimulationResponseBody>;

export default OrderCargoOrderDriverSimulationResponse;
